module.exports = __webpack_public_path__ + "ff7421a59a2209bd4b76eef4cee905c9.png";